export const productNames = {
	WAC: 'marketing',
};
